<template>
    <div>
        <b-form-group :label="showDescription ? 'Tipo de Instalación' : 'Tipología'" label-for="typology">
            <v-select
                v-model="localTypologyId"
                class="pt-0" :label="showDescription ? 'description' : 'name'" :name="showDescription ? 'description' : 'name'"
                :reduce="(option) => option.id"
                :options="typologiesList"
                :disabled="disabled"
                @input="handleTypologyChange"
            />
            <small v-if="validation" class="text-danger">
                {{ validation }}</small>
        </b-form-group>
    </div>
</template>
<script>
import {BFormGroup} from 'bootstrap-vue'
import vSelect from "vue-select"
import {mapState} from "vuex"
import {mapFields} from "vuex-map-fields"

export default {
    components: {
        BFormGroup,
        vSelect,
    },
    props: {
        typologyId: {
            type: Number,
            default: null
        },
        validation: {
            type: String,
            default: null
        },
        showDescription: {
          type: Boolean,
          default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            typologiesList: [],
            typology_name: null
        }
    },
    computed: {
      ...mapState('typologies', []),
      ...mapFields({
        typology: 'typologies.typology',
      }),
      localTypologyId: {
        get() {
          return this.typologyId
        },
        set(value) {
          this.handleTypologyChange(value)
          this.$emit('update', { typology_id: value})
        },
      },
    },
    watch: {
        typologyId(newVal) {
            this.localTypologyId = newVal
            this.$emit('update', { typology_id: this.localTypologyId })
        },
    },
    mounted() {
        this.getTypologies()
    },
    methods:{
        getTypologies() {
            this.showLoading = true

            this.$store.dispatch('typologies/listTypologies')
            .then(response => {
                this.typologiesList = response

                this.showLoading = false
            })
            .catch(error => {
                this.showLoading = false
            })
        },
        handleTypologyChange(selectedTypologyId) {
          const typology = this.typologiesList.find(typology => typology.id === selectedTypologyId)
          if (typology) {
            this.typology_name = typology.name
          }
          this.$emit('update', { typology_name: this.typology_name })
        },
    },

}
</script>
